import React, { useEffect } from "react";
import {useParams, Navigate} from "react-router-dom";

import "./styles.scss";
import {ArticleHtmlPages} from "../../model/TheFactsCategories";

const FactPage = () => {
	const {articleName} = useParams();

	useEffect(()=>{
		let search = window.location.search;
		if(search!=""){
			window.sessionStorage.setItem("utm_source", search.split('?')[1]);
		}
	}, [])

	const article = ArticleHtmlPages.find((art) => art.link === articleName);
	return article ? article.html : <Navigate to="/learn" />;
};

export default FactPage;
